import { render } from "./Signup.vue?vue&type=template&id=6095ca84"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_\\node\\work\\muso-ninjas\\node_modules\\.pnpm\\vue-loader@17.0.1_u4ryg6e3aznhweo4gilim5qufe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__